import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import instagramLogo from './instagram-logo-01.png';
import analyticsService from './services/AnalyticsService.ts';

const footerLinks = {
  legal: [
    { title: 'Privacy Policy', path: '/privacy-policy' },
    { title: 'Legal Disclaimers', path: '/legal-disclaimers' },
    { title: 'Terms of Use', path: '/terms-of-use' },
    { title: 'HIPAA Statement', path: '/hipaa' },
    { title: 'Cannabis Safety Information', path: '/CtCannabisInfo' }
  ],
  main: [
    { title: 'Stores', path: '/store' },
    { title: 'Franchise', path: '/franchising' },
    { title: 'Refund Policy', path: '/refund-policy' },
    { title: 'Accessibility Statement', path: '/accessibility' }
  ],
  social: {
    instagram: 'https://www.instagram.com/sweetspotworryfree',
    email: 'contact@sweetspotfarms.com'
  }
};

const FooterLinkList = ({ links, category }: { 
  links: Array<{ title: string, path: string, isRouter?: boolean }>,
  category: string 
}) => {
  const handleLinkClick = (title: string, path: string, isRouter?: boolean) => {
    analyticsService.trackNavigation({
      link_text: title,
      destination: path,
      source_page: window.location.pathname,
      source_section: 'footer',
      category: category,
      page_path: window.location.pathname
    });
  };

  return (
    <ul className="footer-list">
      {links.map(({ title, path, isRouter }) => (
        <li key={path}>
          {isRouter ? (
            <Link 
              to={path} 
              className="footer-link"
              onClick={() => handleLinkClick(title, path, isRouter)}
            >
              {title}
            </Link>
          ) : (
            <a 
              href={path} 
              className="footer-link"
              onClick={() => handleLinkClick(title, path, isRouter)}
            >
              {title}
            </a>
          )}
        </li>
      ))}
    </ul>
  );
};

const Footer = () => {
  const handleSocialClick = (platform: string, url: string) => {
    analyticsService.trackNavigation({
      link_text: platform,
      destination: url,
      source_page: window.location.pathname,
      source_section: 'footer',
      category: 'social',
      page_path: window.location.pathname
    });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <FooterLinkList links={footerLinks.legal} category="legal" />
        </div>
        <div className="footer-section">
          <FooterLinkList links={footerLinks.main} category="main" />
        </div>
        <div className="footer-section footer-social">
          <div className="footer-divider"></div>
          <div className="footer-text">FOLLOW US:</div>
          <a 
            href={footerLinks.social.instagram} 
            className="footer-icon-link"
            onClick={() => handleSocialClick('instagram', footerLinks.social.instagram)}
          >
            <img 
              src={instagramLogo}
              alt="Instagram" 
              className="footer-social-icon"
            />
          </a>
          <a 
            href={`mailto:${footerLinks.social.email}`} 
            className="footer-email"
            onClick={() => handleSocialClick('email', `mailto:${footerLinks.social.email}`)}
          >
            {footerLinks.social.email}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
